import { render, staticRenderFns } from "./EstructuraComercial.vue?vue&type=template&id=35ca2984&"
import script from "./EstructuraComercial.vue?vue&type=script&lang=ts&"
export * from "./EstructuraComercial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports